import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Alert, Container } from 'react-bootstrap';

import Loader from '../../core/components/Loader';
import { fetchToken } from '../actions/auth';

const OAuthCallback = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [isError, setIsError] = useState(false);

    useEffect(() => {
        // eslint-disable-next-line no-undef
        const url = new URL(window.location.href);
        const code = url.searchParams.get('code');

        dispatch(fetchToken(code, navigate, setIsError));
    }, [navigate]);

    return (
        <Container className="d-flex justify-content-center align-items-center vh-100">
            {isError ? <Alert variant='danger'>Ups, a aparut o problema. Reincearca din nou.</Alert> : <Loader />}
        </Container>
    );
};

export default OAuthCallback;
